import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

import { CharBarSeverity, getCharBarSeverity, getCharBarWidthPct } from "../utils/charCounter.util";

const SEVERITY_BG: Record<CharBarSeverity, string> = {
	ok: "bg-status-success",
	warn: "bg-status-warning",
	danger: "bg-status-error",
};

interface CharCounterProps {
	charCount: number;
	limit: number;
}

/** Character counter of the editor footer: count, progress bar and limit. */
export const CharCounter: FunctionComponent<CharCounterProps> = ({ charCount, limit }) => {
	const severity = getCharBarSeverity(charCount, limit);

	return (
		<div
			className="flex items-center gap-1.5 self-end text-[11.5px] tabular-nums text-text-meta"
			data-test="editor-footer-char-counter"
		>
			<span className="font-medium text-text">{charCount}</span>
			<span className="inline-block w-[50px] h-1 rounded-sm bg-border-light overflow-hidden">
				<span
					className={classNames(
						"block h-full rounded-sm transition-all duration-200",
						SEVERITY_BG[severity]
					)}
					data-test={`editor-footer-char-bar-${severity}`}
					style={{ width: `${getCharBarWidthPct(charCount, limit)}%` }}
				/>
			</span>
			<span>/ {limit}</span>
		</div>
	);
};
